import logger from '@utils/logger';
import { useSwapAssortmentMutation } from '@graphql/generated/graphql';

const useSwapAssortment = () => {
  const { mutate, mutateAsync, isError, isLoading, isSuccess, data } = useSwapAssortmentMutation({
    onError: (error) => {
      let loggedError: Error = Error('swapAssortment failed');
      if (error instanceof Error) {
        loggedError = error;
      }
      void logger.error('Call to swapAssortment resulted in error', loggedError);
    },
    onSuccess: (response) => {
      const { error } = response.swapAssortment;
      if (error) {
        void logger.error('Call to swapAssortment resulted in error', error);
      }
    },
  });
  const { error } = data?.swapAssortment ?? {};
  return {
    mutate,
    mutateAsync,
    isLoading,
    isError: isError || !!error,
    isSuccess,
    error,
  };
};

export default useSwapAssortment;
